import { KeyboardEvent } from 'react';
import { KeyCode } from '@app/const';

const digitKeyCodes = new Set<string>(
  [...Array(10).keys()].flatMap((digit) => {
    return [`Digit${digit}`, `Numpad${digit}`];
  })
);

/** Whether the key is a digit on either the number row or the numeric keypad. */
export function isDigitKey(codeOrEvent: KeyboardEvent | KeyCode) {
  const code = (typeof codeOrEvent === 'string') ? codeOrEvent : (
    codeOrEvent.code as KeyCode
  );
  return digitKeyCodes.has(code);
}
